import React from "react";
import { motion } from "framer-motion";
import ShopBackground from "../../assets/store/store-bg2.jpg";
import noise from "../../assets/beauty/noise.png";
import { useTranslation } from "react-i18next";

export default function Demo() {
	const { t } = useTranslation();
	const primary = "#43BD98";

	return (
		<section
			id="demo"
			style={{
				position: "relative",
				padding: "7rem 2rem",
				textAlign: "center",
				color: "#333",
				fontFamily: "'Poppins', sans-serif",
				backgroundImage: `url(${ShopBackground})`,
				backgroundSize: "cover",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
				backgroundAttachment: "scroll",
			}}
		>
			{/* Textura de ruido */}
			<div
				className="absolute inset-0 opacity-[0.4] pointer-events-none"
				style={{
					backgroundImage: `url(${noise})`,
					backgroundRepeat: "repeat",
					backgroundSize: "250px 250px",
				}}
			/>

			{/* Capa blanca translúcida */}
			<div
				style={{
					position: "absolute",
					inset: 0,
					background: "rgba(255,255,255,0.78)",
					backdropFilter: "blur(6px)",
					zIndex: 0,
				}}
			/>

			{/* Curva superior */}
			<div className="absolute top-[-1px] left-0 w-full overflow-hidden leading-none z-[1]">
				<svg
					className="relative block w-full h-24 text-white"
					viewBox="0 0 1440 60"
					xmlns="http://www.w3.org/2000/svg"
					preserveAspectRatio="none"
				>
					<path d="M0,0 C480,60 960,-20 1440,40 L1440,0 L0,0 Z" fill="#fff" />
				</svg>
			</div>

			{/* Contenido */}
			<div
				style={{
					maxWidth: "800px",
					margin: "0 auto",
					position: "relative",
					zIndex: 2,
				}}
			>
				<motion.h2
					initial={{ opacity: 0, scale: 0.96, filter: "blur(6px)" }}
					whileInView={{
						opacity: 1,
						scale: 1,
						filter: "blur(0px)",
					}}
					transition={{ duration: 0.8, ease: [0.25, 0.1, 0.25, 1] }}
					viewport={{ once: true }}
					style={{
						fontSize: "clamp(1.8rem, 5vw, 2.6rem)",
						fontWeight: 800,
						marginBottom: "1rem",
						color: "#222",
						lineHeight: 1.3,
					}}
				>
					{t("store.demo.title.part1")}{" "}
					<span style={{ color: primary }}>
						{t("store.demo.title.highlight")}
					</span>{" "}
					{t("store.demo.title.part2")}
				</motion.h2>

				<motion.p
					initial={{ opacity: 0, y: 10 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
					viewport={{ once: true }}
					className="text-base md:text-lg max-w-lg mx-auto text-center leading-relaxed mb-10"
					style={{ color: "#555" }}
				>
					{t("store.demo.description")}
				</motion.p>

				<motion.div
					initial={{ opacity: 0, scale: 0.95 }}
					whileInView={{ opacity: 1, scale: 1 }}
					transition={{ duration: 0.7, delay: 0.4, ease: "easeOut" }}
					viewport={{ once: true }}
				>
					<a
						href="/tiendas/demo"
						target="_blank"
						rel="noreferrer"
						style={{
							display: "inline-block",
							padding: "1rem 2.8rem",
							borderRadius: "14px",
							fontWeight: 600,
							background: primary,
							color: "#fff",
							textDecoration: "none",
							transition: "all 0.3s ease",
							boxShadow: "0 6px 20px rgba(67,189,152,0.25)",
						}}
						onMouseEnter={(e) => {
							e.currentTarget.style.transform = "translateY(-2px)";
							e.currentTarget.style.boxShadow =
								"0 10px 25px rgba(67,189,152,0.3)";
						}}
						onMouseLeave={(e) => {
							e.currentTarget.style.transform = "translateY(0)";
							e.currentTarget.style.boxShadow =
								"0 6px 20px rgba(67,189,152,0.25)";
						}}
					>
						{t("store.demo.button")}
					</a>
				</motion.div>
			</div>

			{/* Curva inferior */}
			<div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none z-[1]">
				<svg
					className="relative block w-full h-24 text-white"
					viewBox="0 0 1440 60"
					xmlns="http://www.w3.org/2000/svg"
					preserveAspectRatio="none"
				>
					<path
						d="M0,0 C480,60 960,-20 1440,40 L1440,60 L0,60 Z"
						fill="currentColor"
					/>
				</svg>
			</div>
		</section>
	);
}
